import React, { useState } from "react";

import { useTranslation } from "react-i18next";
import { Button, Checkbox, Col, Input, Row, Select, Switch, Table, Tooltip } from "antd";


const PendingJewelryRequest = () => {
  const { t } = useTranslation();
  const [switchValue, setswitchValue] = useState(true);
  const { Option } = Select;

  function onSearch(val) {}

  const handleSwitch = () => {
    setswitchValue(!switchValue);
  };

  const columns = [
    {
      title: <Tooltip title={t("Store Name")}>{t("Store Name")}</Tooltip>,
      ellipsis: true,
      dataIndex: "storename",
    },
    {
      title: <Tooltip title={t("Retailer Type")}>{t("Retailer Type")}</Tooltip>,
      ellipsis: true,
      dataIndex: "retailertype",
    },
    {
      title: <Tooltip title={t("City")}>{t("City")}</Tooltip>,
      ellipsis: true,
      dataIndex: "city",
    },
    {
      title: <Tooltip title={t("State")}>{t("State")}</Tooltip>,
      ellipsis: true,
      dataIndex: "state",
    },
    {
      title: (
        <Tooltip title={t("Requested Date")}>{t("Requested Date")}</Tooltip>
      ),
      ellipsis: true,
      dataIndex: "requesteddate",
    },
    {
      title: (
        <Tooltip title={t("Action Request")}>{t("Action Request")}</Tooltip>
      ),
      ellipsis: true,
      dataIndex: "actionrequest",
    },
  ];

  const data = [
    {
      key: "1",
      storename: <span>Store 1</span>,
      retailertype: <span>Jewelry</span>,
      city: <span>Mumbai</span>,
      state: <span>Maha</span>,
      requesteddate: <span>01/01/2022</span>,
      actionrequest: (
        <div className="icn__div">
          <i className="fa fa-check chck_icn"></i>
          <i className="fa fa-close clse_icn"></i>
        </div>
      ),
    },
    {
      key: "2",
      storename: <span>Store 1</span>,
      retailertype: <span>Jewelry</span>,
      city: <span>Mumbai</span>,
      state: <span>Maha</span>,
      requesteddate: <span>01/01/2022</span>,
      actionrequest: (
        <div className="icn__div">
          <i className="fa fa-check chck_icn"></i>
          <i className="fa fa-close clse_icn"></i>
        </div>
      ),
    },
    {
      key: "3",
      storename: <span>Store 1</span>,
      retailertype: <span>Jewelry</span>,
      city: <span>Mumbai</span>,
      state: <span>Maha</span>,
      requesteddate: <span>01/01/2022</span>,
      actionrequest: (
        <div className="icn__div">
          <i className="fa fa-check chck_icn"></i>
          <i className="fa fa-close clse_icn"></i>
        </div>
      ),
    },
    {
      key: "4",
      storename: <span>Store 1</span>,
      retailertype: <span>Jewelry</span>,
      city: <span>Mumbai</span>,
      state: <span>Maha</span>,
      requesteddate: <span>01/01/2022</span>,
      actionrequest: (
        <div className="icn__div">
          <i className="fa fa-check chck_icn"></i>
          <i className="fa fa-close clse_icn"></i>
        </div>
      ),
    },
  ];

  return (
    <React.Fragment>
      <div className="pendjewelreq__section">
        <div className="form__fields">
          <div className="col-md-12">
            <h4 className="workarea__heading mt-0">
              {" "}
              {t("Pending Ring Builder Request")}{" "}
            </h4>
          </div>
          <div className="col-lg-12 col-md-12">
            <Table
              className="pendjewelreq__tbl"
              columns={columns}
              dataSource={data}
            />
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default PendingJewelryRequest;
